'use client'
import { CardArticleFileDownload } from 'components/Cards/CardArticleFileDownload/CardArticleFileDownload'
import { Box, Grid } from '@achieve/ascend'
import styles from './PressView.module.scss'
import { ArticleHeading } from 'components/ArticleHeading'
import { AchieveLink } from 'components/AchieveLink/AchieveLink'
import Section from 'components/Section'
import { ArrowLeft } from 'react-feather'
import { ContactPressView } from './ContactsPressView'
import { _get } from 'utils/shared'
import { RelatedArticles } from 'components/RelatedArticles'
import { MediaImageStandard, TypographyLongForm } from 'components/Contentful'
import { CardCTA } from 'components/Cards/CardCTA'
import { Pill } from 'components/Pill'
import { useContentfulInspectorMode } from '@contentful/live-preview/react'
import classNames from 'classnames'

function PressView({ content, completePageUrl }) {
  const inspectorProps = useContentfulInspectorMode()

  const contacts = _get(content, 'pressData.items[0].fields.contacts', false)
  const attachments = content?.pressData?.items[0]?.fields?.attachments || []

  const { relatedArticles } = content
  const mainImage = _get(content, 'pressData.items[0].fields.mainImage')
  const mainImageAlt = _get(content, 'pressData.items[0].fields.mainImage.fields.description')
  const mainText = _get(content, 'pressData.items[0].fields.articleMainBody')
  const widgets = _get(content, 'pressData.items[0].fields.widgets')
  const storyType = _get(content, 'pressData.items[0].fields.storyType')
  const entryId = _get(content, 'pressData.items[0].sys.id')

  return (
    <>
      <Section className={styles['section']} data-testid="press-article">
        <AchieveLink
          href="/about/press"
          className={styles['link-return']}
          data-testid="press-article-cta"
        >
          <div className={styles['link-return-cta']}>
            <ArrowLeft className={styles['link-return-arrow-left']} size={22} />
            <TypographyLongForm
              content={`Return to Press Room`}
              fontWeight="bold"
              variant="bodyLg"
            />
          </div>
        </AchieveLink>
        <ArticleHeading
          content={content}
          hasImage={Boolean(mainImage)}
          data-testid="press-article-heading"
        />
        <Grid container>
          <Grid size={{ xs: 12, lg: 9 }} className={styles['main-body-container']}>
            {mainImage && (
              <div
                className={styles['main-image']}
                {...inspectorProps({
                  entryId,
                  fieldId: 'mainImage',
                })}
              >
                <MediaImageStandard
                  className={classNames(styles['main-image'], 'h-[150px] lg:h-[320px]')}
                  alt={mainImageAlt}
                  content={mainImage}
                  layout="fill"
                />
              </div>
            )}
            {mainText && (
              <div
                className={styles['body-container']}
                {...inspectorProps({
                  entryId,
                  fieldId: 'articleMainBody',
                })}
              >
                <TypographyLongForm content={mainText} />
              </div>
            )}
            {Array.isArray(attachments) && attachments.length > 0 ? (
              <Box
                className={styles['container-cards-contacts']}
                {...inspectorProps({
                  entryId,
                  fieldId: 'attachments',
                })}
              >
                <Box className={styles['container-cards']}>
                  {attachments.map((item, index) => (
                    <CardArticleFileDownload
                      content={item}
                      key={'CardArticleFileDownload' + index}
                    />
                  ))}
                </Box>
              </Box>
            ) : null}

            {contacts ? (
              <Box
                {...inspectorProps({
                  entryId,
                  fieldId: 'contacts',
                })}
              >
                {contacts && <ContactPressView content={contacts} />}
              </Box>
            ) : null}

            <TypographyLongForm
              className={styles['press-topics']}
              content={'Press Topics'}
              variant={'headingMd'}
              component={'h2'}
              fontWeight="medium"
            />
            <Box
              {...inspectorProps({
                entryId,
                fieldId: 'storyType',
              })}
            >
              <Pill className={styles['pills']} category={storyType} id={0} />
            </Box>
          </Grid>
          <Grid size={{ xs: 12, lg: 3 }} className={styles['siderail-container']}>
            {relatedArticles && (
              <RelatedArticles
                relatedArticles={relatedArticles}
                completePageUrl={completePageUrl}
              />
            )}
            {widgets && (
              <div className="hidden lg:block">
                {widgets.map((card, idx) => {
                  return <CardCTA content={card.fields} key={idx} variant={'widget'} />
                })}
              </div>
            )}
          </Grid>
        </Grid>
      </Section>
    </>
  )
}

export { PressView }
